import { IJob } from './Job';

export interface IJobScheduler{
  start()
  stop()
  resume()
  pushNewJob(task: IJob)
  removeJob(taskId: String)
}

/** define report job scheduler component */
export default class ReportJobScheduler implements IJobScheduler{
  tasks: IJob[];
  scheduleTimer:any

  timeout: number = 60000 // 1 minutes

  constructor() {
    //super();
    this.tasks = [];
  }

  /** STOP */
  start() {
    this.scheduleTimer = window.setInterval(() => {
      console.log('schedule runing...')

      // RUN JOB FOR SEND MESSAGE 
      this.tasks.forEach(x=>{
        x.excuted();
      });
      
    },this.timeout);
  }

  /** STOP */
  stop() {
    window.clearInterval(this.scheduleTimer);
  }

  /** STOP */
  resume() {
    this.start()
  }

  pushNewJob(task: IJob){
    this.tasks.push(task);
  }
  
  removeJob(taskId: string){
    console.log("runJobToGetNotification", taskId, "remove" , new Date().toLocaleTimeString());

    let index = this.tasks.findIndex(c=>c.Id == taskId);
    this.tasks.splice(index, 1);
  }
}